<div [formGroup]="group"
     fxLayout="column"
     fxFlex>
  <div fxLayout="row wrap" fxLayoutGap="10px" fxLayoutAlign="start center">
    <mat-label>{{field.label}}<span *ngIf="field.required" class="required-star">*</span>:</mat-label>
    <mat-radio-group [formControlName]="field.name"
                     fxLayout="row wrap"
                     fxLayoutGap="10px">
      <mat-radio-button *ngFor="let item of field.options"
                        [value]="item.value"
                        [checked]="group.get(field.name)?.value === item.value">{{item.label|translate}}</mat-radio-button>
    </mat-radio-group>
  </div>
  <ng-container *ngFor="let validation of field.validations;">
    <mat-error *ngIf="group.get(field.name)?.hasError(validation.name) && (group.get(field.name)?.touched || group.get(field.name)?.dirty)"
               [translate]="validation.message"
               [translateParams]="{field:field.label}">
    </mat-error>
  </ng-container>
</div>
